import { FC } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  title?: string;
}

const BackButton: FC<BackButtonProps> = (props) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => navigate(-1)}
        aria-label="Go back"
        className="bg-transparent border-none p-0 cursor-pointer outline-none focus:outline-none active:bg-transparent hover:bg-transparent"
      >
        <ArrowLeftOutlined />
      </button>
      <h3 className="m-0">{props?.title ?? "Back"}</h3>
    </div>
  );
};

export default BackButton;
